// extracted by mini-css-extract-plugin
module.exports = {"sidenav-footer-alignment":"styles_sidenav-footer-alignment__15__c","logo-image":"styles_logo-image__TqCb7"};